export const Mock = {
	modulos: [
		//{
		//	image: 'orientacion-aprendizaje.png',
		//	title: 'Orientación para el aprendizaje',
		//	route: 'orientacion-aprendizaje'
		//},
		//{image: 'nivelacion.png', title: 'Nivelación de competencias Académicas', route: 'nivelacion'},
		{image: 'movilidad.png', title: 'Movilidad', route: 'movilidad'},
		{image: 'acreditacion.png', title: 'Aseguramiento de la Calidad y Analisis Institucional', route: 'aseguramiento-calidad-analisis-institucional'},
		{image: 'google.png', title: 'Herramientas Google', route: 'herramientas-google'},
		{image: 'vinculate.png', title: 'Vinculate', route: 'vinculate'},
		{image: 'Tuyonosotres.png', title: 'Unidad de Género', route: 'genero'},
		{
			image: 'biblioteca.png',
			title: 'Biblioteca y Recursos de Aprendizaje',
			route: 'biblioteca'
		},
		{image: 'desarrollo-estudiantil.png', title: 'Desarrollo Estudiantil', route: 'desarrollo-estudiantil'},
	],
	
	contenido_modulos_2022: {
		'orientacion-aprendizaje': {
			image: 'orientacion-aprendizaje.png',
			name: 'Orientación para el aprendizaje',
			title: '¿Como adaptarme a la vida universitaria?',
			text: '¿Qué significa entrar a la Universidad? ¿Cómo lo haré para organizarme? ¿Cómo me adapto a este nuevo mundo después de 2 años de Pandemia? En estos Talleres intentaremos brindarte respuesta a estas y otras preguntas, y además te brindaremos algunos TIPS relevantes para dar inicio de buena manera a este nuevo desafío de ingresar a la Universidad. Te entregaremos algunas herramientas y reflexiones que te serán de utilidad para adaptarte de manera exitosa a la vida universitaria y conseguir tus objetivos!',
			info: {
				type: 'slide',
				data: [
					{img: 'orientación.jpg', pdf: 'orientación.pdf'},
				]
			}
		},
		'nivelacion': {
			image: 'nivelacion.png',
			name: 'Nivelación de competencias Académicas',
			title: 'Pincha el área en que necesitas nivelarte',
			text: 'Iniciar algo nuevo puede traer consigo algunos temores, ¿estaré realmente preparadx para esto?        ¿Los conocimientos que tengo serán suficientes para comenzar y mantenerme en carrera? ¿Seré capaz de enfrentar todos estos desafíos?. El Equipo de Acompañamiento Académico sabe que no será fácil, pero quiere acompañarte y hacer de este tránsito algo que también recuerdes. El periodo de nivelación es una instancia donde profesionales de las áreas de Química, Matemáticas y Lenguaje realizarán cursos introductorios que te permitirán afrontar tus cursos de mejor manera.',
			info: {
				type: 'tab',
				data: [
					{
						title: 'Introducción a la Química',
						image: 'quimica.png',
						text: 'En estas sesiones podrás acercarte a algunos conceptos básicos de la química que te permitirán afrontar sus asignaturas mejor preparada/o.<br> ¿Por qué “Química”? esta área es importantísima y la base para la mayoría de las asignaturas que tendrás en tu carga académica como estudiante de salúd y otras ciencias naturales, es vital que puedas enfrentarte a ellas con menos temores. En este curso introductorio buscaremos acercarte a esta disciplina de una manera amable y divertida, entregándote herramientas que te hagan sentir más confiado/a para enfrentar este gran desafío.'
					},
					{
						title: 'Introducción al Lenguaje',
						image: 'comprension-lectora.png',
						text: 'En estas sesiones podrás conocer algunos elementos que son básicos para enfrentar el área del Lenguaje en tu vida académica.<br>¿Por qué "Lenguaje"? Porque debes recordar que poder expresarte correctamente en la oralidad y en la escritura es fundamental para desarrollarte como ser humano y sobre todo como futuro profesional. Trataremos de que puedas afianzar algunos conocimientos y habilidades para que te sientas más empoderado/a para enfrentar este nuevo desafío.<br>"Los límites de mi lenguaje son los límites de mi mundo" (Ludwig Wittgenstein)'
					},
					{
						title: 'Introducción a las Matemáticas',
						image: 'matematicas.png',
						text: 'En estas sesiones podrás conocer algunos elementos que son básicos para enfrentar el área de Matemática en tu vida académica.<br>¿Por qué “Matemáticas”? Porque debes recordar que las matemáticas están presentes en cualquier faceta de nuestra vida diaria, es por esto que trataremos de que puedas afianzar algunos conocimientos y habilidades para que te sientas más empoderado/a para enfrentar este nuevo desafío.\n'
					},
				]
			}
		},
		'movilidad': {
			image: 'movilidad.png',
			name: 'Movilidad Estudiantil',
			title: 'Movilidad',
			text: 'Esta actividad tiene relación con la presentación de aspectos relevantes en relación a la oportunidad de realizar asignaturas en otras universidades del país o del mundo.<br>¿Por qué considerar hacer movilidad estudiantil?, porque podrás conocer otras modalidades de estudio, enriquecer tu formación profesional y vivir otras experiencias personales.',
			info: {
				type: 'slide',
				data: [
					{img: 'movilidad.jpg', pdf: 'movilidad.pdf'},
				]
			}
		},
		'acreditacion': {
			image: 'acreditacion.png',
			name: 'Acreditación',
			title: 'Acreditación',
			text: 'En esta sesión queremos invitarte a que conozcas la importancia y repercusión que tiene para la Institución el proceso de Acreditación Institucional, proceso del que tú también formas parte.<br>La Universidad de Aysén depende de todos y todas, únete al proceso de acreditación.<br>¡Contamos contigo!',
			info: {
				type: 'slide',
				data: [
					{img: 'acreditacion.jpg', pdf: 'acreditacion.pdf'},
				]
			}
		},
		'herramientas-google': {
			image: 'google.png',
			name: 'Herramientas de Google',
			title: 'Herramientas de Google',
			text: 'En este taller podrás adquirir conocimientos básicos sobre el funcionamiento de las diferentes aplicaciones de Google, a las cuales puedes acceder desde tu cuenta de correo institucional.<br>El correcto manejo de la tecnología será útil para la organización de tus trabajos, para reducir tareas repetitivas y para mejorar la gestión de tu tiempo, entre otras cosas.<br>¡Te esperamos!',
			info: {
				type: 'video',
				data: [
					'ddtuUiLP_xQ',
					'nEQYhUKO5gc',
					'dBWBoncssik',
					'eDBMdbKlOOg',
					'3pI8lhewiWs',
					'y2VJXDYV6oc',
				]
			}
		},
		'vinculate': {
			image: 'vinculate.png',
			name: 'Vincúlate',
			title: 'Vincúlate',
			text: 'La Unidad de Vinculación con el Medio busca generar un nexo entre la Universidad y la comunidad, llevando a cabo acciones socialmente significativas que beneficien a ambas componentes. La Universidad de Aysén busca contribuir y potenciar el desarrollo e innovación regional a través de diversas actividades. Durante la semana de inducción la Unidad de Vinculación con el Medio ha generado una interesante actividad para que puedas conocer cómo tu nueva casa de estudios se involucra con el territorio y su gente.',
			info: {
				type: 'slide',
				data: [
					{img: 'vinculate1.jpg', pdf: 'vinculate.pdf'},
					{img: 'vinculate2.jpg', pdf: 'vinculate.pdf'},
				]
			}
		},
		'yo-tu-nosotres': {
			image: 'Tuyonosotres.png',
			name: 'Yo, Tú, Nosotres',
			title: 'Yo, Tú, Nosotres',
			text: 'Conocer cómo podemos prevenir la violencia de género y la discriminación es tarea de todo@s, para ello la actividad que se ha preparado está pensada en revisar nuestra normativa para aprender a identificar situaciones de violencia y discriminación.<br>¿Por qué es importante? Porque ahora eres parte de nuestra institución y es relevante que tod@s podamos aportar a la erradicación de la violencia y discriminación.<br>¡Contamos contigo!',
			info: {
				type: 'slide',
				data: [
					{img: 'genero.jpg', pdf: 'genero.pdf'},
				]
			}
		},
		'biblioteca': {
			image: 'biblioteca.png',
			name: 'Biblioteca y Recursos de Aprendizaje',
			title: 'Biblioteca y Recursos de Aprendizaje',
			text: 'En este taller podrás conocer los servicios y recursos de aprendizaje que tiene nuestra Biblioteca.<br>Las bibliotecas son nuestra vía para profundizar nuestros conocimientos, por eso es importante que puedas asistir a este taller.<br>¡Te esperamos!',
			info: {
				type: 'slide',
				data: [
					{img: 'biblioteca.jpg', pdf: 'biblioteca.pdf'},
				]
			}
		},
		'desarrollo-estudiantil': {
			image: 'desarrollo-estudiantil.png',
			name: 'Desarrollo Estudiantil',
			title: 'Desarrollo Estudiantil',
			text: 'La Unidad de Desarrollo Estudiantil de la Universidad de Aysén está encargada del acompañamiento y formación extracurricular de los estudiantes a través de áreas transversales como: Bienestar, Deporte, Liderazgo y Vida Estudiantil. Durante la semana de inducción esta unidad ha desarrollado una serie de actividades dedicadas a que conozcas los espacios de la universidad e informarte sobre su quehacer en nuestra institución.',
			info: {
				type: 'slide',
				data: [
					{img: 'desarrollo-estudiantil.jpg', pdf: 'desarrollo-estudiantil.pdf'},
				]
			}
		},
	},
	
	contenido_modulos_2023: {
		'nivelacion': {
			image: 'nivelacion.png',
			name: 'Nivelación de competencias Académicas',
			title: 'Pincha el área en que necesitas nivelarte',
			text: 'Iniciar algo nuevo puede traer consigo algunos temores, ¿estaré realmente preparadx para esto?        ¿Los conocimientos que tengo serán suficientes para comenzar y mantenerme en carrera? ¿Seré capaz de enfrentar todos estos desafíos?. El Equipo de Acompañamiento Académico sabe que no será fácil, pero quiere acompañarte y hacer de este tránsito algo que también recuerdes. El periodo de nivelación es una instancia donde profesionales de las áreas de Química, Matemáticas y Lenguaje realizarán cursos introductorios que te permitirán afrontar tus cursos de mejor manera.',
			info: {
				type: 'tab',
				data: [
					{
						title: 'Introducción a la Química',
						image: 'quimica.png',
						text: 'En estas sesiones podrás acercarte a algunos conceptos básicos de la química que te permitirán afrontar sus asignaturas mejor preparada/o.<br> ¿Por qué “Química”? esta área es importantísima y la base para la mayoría de las asignaturas que tendrás en tu carga académica como estudiante de salúd y otras ciencias naturales, es vital que puedas enfrentarte a ellas con menos temores. En este curso introductorio buscaremos acercarte a esta disciplina de una manera amable y divertida, entregándote herramientas que te hagan sentir más confiado/a para enfrentar este gran desafío.'
					},
					{
						title: 'Introducción al Lenguaje',
						image: 'comprension-lectora.png',
						text: 'En estas sesiones podrás conocer algunos elementos que son básicos para enfrentar el área del Lenguaje en tu vida académica.<br>¿Por qué "Lenguaje"? Porque debes recordar que poder expresarte correctamente en la oralidad y en la escritura es fundamental para desarrollarte como ser humano y sobre todo como futuro profesional. Trataremos de que puedas afianzar algunos conocimientos y habilidades para que te sientas más empoderado/a para enfrentar este nuevo desafío.<br>"Los límites de mi lenguaje son los límites de mi mundo" (Ludwig Wittgenstein)'
					},
					{
						title: 'Introducción a las Matemáticas',
						image: 'matematicas.png',
						text: 'En estas sesiones podrás conocer algunos elementos que son básicos para enfrentar el área de Matemática en tu vida académica.<br>¿Por qué “Matemáticas”? Porque debes recordar que las matemáticas están presentes en cualquier faceta de nuestra vida diaria, es por esto que trataremos de que puedas afianzar algunos conocimientos y habilidades para que te sientas más empoderado/a para enfrentar este nuevo desafío.\n'
					},
				]
			}
		},
		'acompanamiento-academico': {
			image: 'acompanamiento.png',
			name: 'Acompañamiento Académico',
			title: 'Acompañamiento Académico',
			text: 'Sabemos que tu paso por la universidad será una etapa importantísima y marcará tu vida,\n' +
				'en este viaje te enfrentarás a muchos desafíos que pondrán a prueba tus habilidades.\n' +
				'Nosotros, el Equipo de Acompañamiento Académico (EAA), queremos ser parte de este\n' +
				'transitar acompañándote en el proceso.',
			info: {
				type: 'slide',
				data: [
					{img: 'acompanamiento.jpg', pdf: 'acompanamiento.pdf'},
				]
			}
		},
		'vinculate': {
			image: 'vinculate.png',
			name: 'Vincúlate',
			title: 'Vincúlate',
			text: 'La Dirección de Vinculación con el medio tiene como objetivo el desarrollo de acciones, proyectos y\n' +
				'programas que, con un alto contenido académico, articulan el accionar con el territorio y sus\n' +
				'comunidades.\n' +
				'Este trabajo tiene un carácter bidireccional, es decir, busca la colaboración y co-creación con las\n' +
				'comunidades, generando oportunidades de crecimiento y aprendizaje recíproco, contribuyendo con\n' +
				'ello al aseguramiento de la calidad institucional.',
			info: {
				type: 'slide',
				data: [
					{img: 'vinculate1.jpg', pdf: 'vinculate.pdf'},
					{img: 'vinculate2.jpg', pdf: 'vinculate.pdf'},
				]
			}
		},
		'genero': {
			image: 'Tuyonosotres.png',
			name: 'Unidad de Género UAysén',
			title: 'Unidad de Género UAysén',
			text: 'La Unidad de Equidad de Género, dependiente de Rectoría, fue creada el\n' +
				'año 2018 con el fín de dar cumplimiento al compromiso asumido por el\n' +
				'Consejo de Rectores y rectoras de las Universidad de Chile (CRUCH) en\n' +
				'diálogo con el movimiento feminista, de establecer unidades o direcciones de género en cada Universidad.',
			info: {
				type: 'slide',
				data: [
					{img: 'genero.jpg', pdf: 'genero.pdf'},
				]
			}
		},
		'movilidad': {
			image: 'movilidad.png',
			name: 'Movilidad Estudiantil',
			title: 'Movilidad',
			text: 'Promovemos la realización de actividades académicas\n' +
				'en otras universidades de Chile y el extranjero para\n' +
				'que puedas estudiar bajo el programa de movilidad\n' +
				'estudiantil. De la misma forma, promovemos que\n' +
				'estudiantes de otras universidades estudien en la\n' +
				'UAysén, generando un ambiente diverso que\n' +
				'enriquece la formación integral. Así, podrás conocer\n' +
				'distintos estilos de enseñanza, compartir con nuevos\n' +
				'académicos y compañeros y aprender conocimientos\n' +
				'en un programa que permite vivir nuevas experiencias\n' +
				'que, sin duda, marcarán tu formación académica y\n' +
				'personal.',
			info: {
				type: 'slide',
				data: [
					{img: 'movilidad.jpg', pdf: 'movilidad.pdf'},
				]
			}
		},
		'biblioteca': {
			image: 'biblioteca.png',
			name: 'Biblioteca y Recursos de Aprendizaje',
			title: 'Biblioteca y Recursos de Aprendizaje',
			text: 'Proveer servicios y recursos de aprendizaje contenidos en los programas de asignatura, publicaciones regionales.',
			info: {
				type: 'slide',
				data: [
					{img: 'biblioteca.jpg', pdf: 'biblioteca.pdf'},
				]
			}
		},
		'desarrollo-estudiantil': {
			image: 'desarrollo-estudiantil.png',
			name: 'Desarrollo Estudiantil',
			title: 'Desarrollo Estudiantil',
			text: 'La Unidad de Desarrollo Estudiantil tiene como objetivo asegurar las condiciones\n' +
				'necesarias para que los y las estudiantes puedan desarrollar en forma adecuada su\n' +
				'formación académica y profesional, abarcando especialmente aspectos\n' +
				'relacionados con los perfiles socioeconómicos, desarrollo personal y capital social\n' +
				'de los y las estudiantes de la institución.\n',
			info: {
				type: 'slide',
				data: [
					{img: 'desarrollo-estudiantil.jpg', pdf: 'desarrollo-estudiantil.pdf'},
				]
			}
		},
		'aseguramiento-calidad-analisis-institucional': {
			image: 'acreditacion.png',
			name: 'Aseguramiento de la Calidad y Análisis Institucional',
			title: 'Aseguramiento de la Calidad y Análisis Institucional',
			text: 'La UACAI ( Unidad de Aseguramiento de la calidad y Análisis Institucional, se ubica dentro de la\n' +
				'Dirección de Planificación y Aseguramiento de la Calidad (DPAC), y es la encargada de ejecutar el\n' +
				'proceso de aseguramiento de la calidad, ( acreditación) desde sus distintos ámbitos, contribuye a la\n' +
				'generación de procesos, sistemas e información que nos permiten construir una universidad de\n' +
				'calidad.',
			info: {
				type: 'slide',
				data: [
					{img: 'aseguramiento-calidad-analisis-institucional.jpg', pdf: 'aseguramiento-calidad-analisis-institucional.pdf'},
				]
			}
		},
		'herramientas-google': {
			image: 'google.png',
			name: 'Herramientas de Google',
			title: 'Herramientas de Google',
			text: 'En este taller podrás adquirir conocimientos básicos sobre el funcionamiento de las diferentes aplicaciones de Google, a las cuales puedes acceder desde tu cuenta de correo institucional.<br>El correcto manejo de la tecnología será útil para la organización de tus trabajos, para reducir tareas repetitivas y para mejorar la gestión de tu tiempo, entre otras cosas.<br>¡Te esperamos!',
			info: {
				type: 'video',
				data: [
					'ddtuUiLP_xQ',
					'nEQYhUKO5gc',
					'dBWBoncssik',
					'eDBMdbKlOOg',
					'3pI8lhewiWs',
					'y2VJXDYV6oc',
				]
			}
		},
	},
	
	redes: [
		{link: 'https://www.facebook.com/udeaysen', image: 'facebook.png', name: 'Facebook'},
		{link: 'https://www.instagram.com/universidad_de_aysen/', image: 'instagram.png', name: 'Instagram'},
		{link: 'https://twitter.com/UdeAysen', image: 'twitter.png', name: 'Twitter'},
		{link: 'https://www.youtube.com/c/UniversidaddeAys%C3%A9n', image: 'youtube.png', name: 'Youtube'},
	],
	
	programas: [
		{
			image: 'forestal.png',
			title: 'Ingeniería Forestal',
			route: 'forestal',
			color: 'forestal'
		},
		{
			image: 'agronomia.png',
			title: 'Agronomía',
			route: 'agronomia',
			color: 'agronomia'
		},
		{
			image: 'obstetricia.png',
			title: 'Obstetricia',
			route: 'obstetricia',
			color: 'obstetricia'
		},
		{
			image: 'enfermeria.png',
			title: 'Enfermería',
			route: 'enfermeria',
			color: 'enfermeria'
		},
		{
			image: 'civil-industrial.png',
			title: 'Ingeniería Civil Industrial ',
			route: 'civil-industrial',
			color: 'civil-industrial'
		},
		{
			image: 'informatica.png',
			title: 'Ingeniería Civil Informatica',
			route: 'informatica',
			color: 'informatica'
		},
		{
			image: 'psicologia.png',
			title: 'Psicología',
			route: 'psicologia',
			color: 'psicologia'
		},
		{
			image: 'trabajo-social.png',
			title: 'Trabajo Social',
			route: 'trabajo-social',
			color: 'trabajo-social'
		},
	],
}